import React from 'react'
import Error_img from "../../assets/images/bg404.png"

const Error = () => {
    return (
        <div className='flex justify-center items-center h-screen flex-col bg-[#fff] space-y-2'>
            <img
                src={Error_img}
                alt='404-bg-img'
                className='w-full max-w-[620px] max-h-[500px]  object-contain'

            />

            {/* Heading and Paragraph */}
            <div className='flex flex-col justify-center items-center text-center space-y-2 p-2'>
                <h2 className='text-3xl font-bold text-[#000000]'>Oops! This Page Flew Away...</h2>
                <p className='text-[#000000] text-base'>We can't seem find the page you're looking. Maybe a took's a break for some extra credit?</p>
            </div>


            {/* Button */}
            <div className='flex justify-center items-center flex-row space-x-5 sm:p-2 p-2 mb-5'>
                <button onClick={() => window.location.href = "/"} className='bg-[#f2883a] text-white px-4 py-2 rounded-lg'>
                    GO TO HOMEPAGE
                </button>
            </div>

        </div>
    )
}

export default Error